import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { ShrinkToFit } from '@bittnerdevelopmentgroup/interactive';
import { useForceUpdate, numberToLetter, isValidURL, getRawText } from '../util';
import { Content } from '../DataStructures';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import Dropdown from 'react-bootstrap/Dropdown';
import { TabContextReporter } from '../TabContext';
import { Row, Col } from 'react-bootstrap';
import NumericInput from 'react-numeric-input';
const DEBUG = false;
export function parseTranslate(translate) {
  if (translate == undefined) return {
    x: 0,
    y: 0
  };
  let x = parseInt(translate.substring(translate.indexOf('(') + 1, translate.indexOf(',') - 2));
  let y = parseInt(translate.substring(translate.indexOf(',') + 2, translate.indexOf(')') - 2));
  DEBUG && console.log("TaskCallout parseTranslate", x, y);
  return {
    x,
    y
  };
}
export function parsePositionFromStyle(style) {
  let pos = {
    x: parseInt(style.left),
    y: parseInt(style.top)
  };
  //DEBUG && console.log("TaskCallout parsePositionFromStyle", pos)
  return pos;
}
const resizeSize = 10;
const minWidth = 10;
export function HotspotEditor({
  hs,
  picture,
  forceUpdate,
  triggerStateUpdate,
  onChanged
}) {
  const imgRef = React.useRef();
  const hotspotRef = React.useRef();
  const [innerScale, setInnerScale] = React.useState(1);
  const [dragStart, setDragStart] = React.useState([-1, -1]);
  const [sizeStart, setSizeStart] = React.useState([-1, -1]);
  const [offsetStart, setOffsetStart] = React.useState([-1, -1]);
  const draggingRef = React.useRef(false);
  function checkBounds(style, imgRef) {
    let rect = imgRef.current.getBoundingClientRect();
    let w = rect.width / innerScale;
    let h = rect.height / innerScale;
    if (parseInt(style.left) < 0) style.left = 0;
    if (parseInt(style.top) < 0) style.top = 0;
    if (parseInt(style.width) > w) style.width = w + 'px';
    if (parseInt(style.height) > h) style.height = h + 'px';
    if (parseInt(style.left) + parseInt(style.width) > w) style.left = w - parseInt(style.width) + 'px';
    if (parseInt(style.top) + parseInt(style.height) > h) style.top = h - parseInt(style.height) + 'px';
  }
  const mouseup = e => {
    if (dragStart[0] === -1 && dragStart[1] === -1 || !draggingRef.current) return;
    DEBUG && console.log("TaskCallout up");
    let deltaX = e.clientX - dragStart[0];
    let deltaY = e.clientY - dragStart[1];
    if (draggingRef.current === "pos") {
      hs.style.left = parseInt(hs.style.left) + deltaX / innerScale + 'px';
      hs.style.top = parseInt(hs.style.top) + deltaY / innerScale + 'px';
    } else {
      let [w, h] = sizeStart;
      if (draggingRef.current === "both" || draggingRef.current === "w") hs.style.width = Math.max(minWidth / innerScale, w + deltaX / innerScale) + 'px';
      if (draggingRef.current === "both" || draggingRef.current === "h") hs.style.height = Math.max(minWidth / innerScale, h + deltaY / innerScale) + 'px';
    }
    DEBUG && console.log("TaskCallout resize up", deltaX, deltaY);
    checkBounds(hs.style, imgRef);
    setDragStart([-1, -1]);
    setSizeStart([-1, -1]);
    draggingRef.current = false;
    onChanged();
    triggerStateUpdate();
  };
  const mousemove = e => {
    if (dragStart[0] === -1 && dragStart[1] === -1 || !draggingRef.current) return;
    let deltaX = e.clientX - dragStart[0];
    let deltaY = e.clientY - dragStart[1];
    //DEBUG && console.log("TaskCallout move", deltaX, deltaY)
    if (draggingRef.current === "pos") {
      hotspotRef.current.style.left = parseInt(hs.style.left) + deltaX / innerScale + 'px';
      hotspotRef.current.style.top = parseInt(hs.style.top) + deltaY / innerScale + 'px';
    } else {
      let [w, h] = sizeStart;
      if (draggingRef.current === "both" || draggingRef.current === "w") hotspotRef.current.style.width = Math.max(minWidth / innerScale, w + deltaX / innerScale) + 'px';
      if (draggingRef.current === "both" || draggingRef.current === "h") hotspotRef.current.style.height = Math.max(minWidth / innerScale, h + deltaY / innerScale) + 'px';
    }
    checkBounds(hotspotRef.current.style, imgRef);
  };
  React.useEffect(() => {
    document.addEventListener("mouseup", mouseup);
    document.addEventListener("mousemove", mousemove);
    return () => {
      document.removeEventListener("mouseup", mouseup);
      document.removeEventListener("mousemove", mousemove);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "hotspot-editor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "position-relative mb-3 mw-100"
  }, /*#__PURE__*/React.createElement(ShrinkToFit, {
    onInnerScaleChange: setInnerScale
  }, /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    id: "calloutImage",
    src: picture,
    className: "unselectable",
    style: {
      width: '560px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: hotspotRef,
    style: {
      ...hs.style,
      position: 'absolute',
      backgroundColor: "rgba(255, 0, 255, 0.75)",
      userSelect: 'none',
      cursor: 'move',
      borderRadius: hs.shape === "Circle" ? "50%" : undefined
    },
    onMouseDown: e => {
      let rect = e.target.getBoundingClientRect();
      let offsetX = e.clientX - rect.left;
      let offsetY = e.clientY - rect.top;
      /*let right = rect.right - e.clientX
      let bottom = rect.bottom - e.clientY
      if (right < resizeSize / innerScale && bottom < resizeSize / innerScale) {
        DEBUG && console.log("TaskCallout onStart aborted")
        return false
      }*/
      DEBUG && console.log("TaskCallout onStart", offsetX, offsetY);
      setDragStart([e.clientX, e.clientY]);
      setOffsetStart([offsetX, offsetY]);
      draggingRef.current = "pos";
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "resize-handle",
    style: {
      cursor: 'e-resize',
      position: 'absolute',
      width: resizeSize / innerScale + 'px',
      top: 0,
      right: 0,
      bottom: resizeSize / innerScale + 'px'
    },
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
      DEBUG && console.log("TaskCallout resize down");
      setDragStart([e.clientX, e.clientY]);
      setSizeStart([parseInt(hs.style.width), parseInt(hs.style.height)]);
      draggingRef.current = "w";
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "resize-handle",
    style: {
      cursor: 's-resize',
      position: 'absolute',
      height: resizeSize / innerScale + 'px',
      left: 0,
      right: resizeSize / innerScale + 'px',
      bottom: 0
    },
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
      DEBUG && console.log("TaskCallout resize down");
      setDragStart([e.clientX, e.clientY]);
      setSizeStart([parseInt(hs.style.width), parseInt(hs.style.height)]);
      draggingRef.current = "h";
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "resize-handle",
    style: {
      cursor: 'se-resize',
      position: 'absolute',
      width: resizeSize / innerScale + 'px',
      height: resizeSize / innerScale + 'px',
      right: 0,
      bottom: 0
    },
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
      DEBUG && console.log("TaskCallout resize down");
      setDragStart([e.clientX, e.clientY]);
      setSizeStart([parseInt(hs.style.width), parseInt(hs.style.height)]);
      draggingRef.current = "both";
    }
  })))));
}
export default function TaskCallout(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const hotspots = dataProps.hotspots;
  const picture = dataProps.picture;
  const [activeKey, setActiveKey] = React.useState(null);
  const [bounds, setBounds] = React.useState(false);
  const hs = hotspots[activeKey];
  const ltwh = ["left", "top", "width", "height"];
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. General information"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.picture,
    onChange: e => {
      dataProps.picture = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: isValidURL(dataProps.picture)
  }, "Please enter a valid URL.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Caption:"), " ", /*#__PURE__*/React.createElement("i", null, "A figurative description of the image.")), /*#__PURE__*/React.createElement(RichText, {
    forceWrap: true,
    value: dataProps.details,
    onChange: v => {
      dataProps.details = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.alt,
    onChange: e => {
      dataProps.alt = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: dataProps.alt.length > 0
  }, "Please enter alt text.")), /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "success",
    onClick: () => {
      hotspots.push({
        content: new Content("Hotspot tooltip content"),
        label: "Hotspot " + numberToLetter(hotspots.length),
        placement: "bottom",
        style: {
          top: "0px",
          left: "0px",
          width: "70px",
          height: "70px"
        }
      });
      props.triggerStateUpdate();
      props.refreshTabList();
      forceUpdate();
      props.onChanged();
    }
  }, "Add New Hotspot")), hotspots.map((hotspot, i) => {
    const letter = numberToLetter(i);
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      index: i + 1,
      title: hotspots[i].label
    }, /*#__PURE__*/React.createElement(HotspotEditor, {
      hs: hotspots[i],
      picture: picture,
      forceUpdate: forceUpdate,
      triggerStateUpdate: props.triggerStateUpdate,
      onChanged: props.onChanged
    }), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Label:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the area covered by this hotspot.")), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: hotspots[i].label,
      onChange: e => {
        hotspots[i].label = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Content:"), " ", /*#__PURE__*/React.createElement("i", null, "Text to display in the tooltip.")), /*#__PURE__*/React.createElement(RichText, {
      value: hotspots[i].content,
      onChange: v => {
        hotspots[i].content = v;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Hotspot Tooltip Direction:")), /*#__PURE__*/React.createElement(Dropdown, {
      className: "mx-2"
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basic"
    }, hotspots[i].placement), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].placement = "right";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Right"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].placement = "left";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Left"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].placement = "top";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Top"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].placement = "bottom";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Bottom")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Hotspot Shape:")), /*#__PURE__*/React.createElement(Dropdown, {
      className: "mx-2"
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basic"
    }, hotspots[i].shape), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].shape = "Square";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Square"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].shape = "Circle";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Circle")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Hotspot Dimensions:")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, "Width: ", /*#__PURE__*/React.createElement(NumericInput, {
      style: {
        margin: 'auto'
      },
      size: "1",
      value: parseInt(hotspots[i].style.width),
      onChange: e => {
        if (e) {
          hotspots[i].style.width = e + "px";
        } else {
          hotspots[i].style.width = "0px";
        }
        forceUpdate();
      }
    })), /*#__PURE__*/React.createElement(Col, null, "Height: ", /*#__PURE__*/React.createElement(NumericInput, {
      style: {
        margin: 'auto'
      },
      size: "1",
      value: parseInt(hotspots[i].style.height),
      onChange: e => {
        if (e) {
          hotspots[i].style.height = e + "px";
        } else {
          hotspots[i].style.height = "0px";
        }
        forceUpdate();
      }
    })))), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "danger",
      onClick: () => {
        hotspots.splice(i, 1);
        props.triggerStateUpdate();
        props.decrementActiveTab();
        forceUpdate();
        props.onChanged();
      }
    }, "Remove Hotspot"));
  }), hotspots.map((hotspot, i) => {
    const letter = numberToLetter(i);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: getRawText(hotspots[i].content).length > 0
    }, "Please enter some content for hotspot ", letter, "."), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: hotspots[i].label.length > 0
    }, "Please enter an accessible label for hotspot ", letter, "."));
  })));
}